import {
  axiosClient,
  getCSRFToken,
  getFormDataFromObject,
} from 'www/utils'

function sendViewBannerRequest(viewBannerRequestData) {
  const csrfmiddlewaretoken = getCSRFToken()

  if (!csrfmiddlewaretoken) {
    return
  }

  const {
    percents,
    redisId,
    campaign,
    type,
  } = viewBannerRequestData

  if (!campaign) {
    return
  }

  const requestData = {
    p: percents,
    c: campaign,
    btype: type,
    csrfmiddlewaretoken,
    redis_id: redisId,
  }
  const requestFormData = getFormDataFromObject(requestData)

  axiosClient
    .post('/ajax/view_banner/', requestFormData)
    .catch(() => {})
}

export default sendViewBannerRequest
